import { render, staticRenderFns } from "./sendEmailDetail.vue?vue&type=template&id=59d8f9cc&scoped=true&"
import script from "./sendEmailDetail.vue?vue&type=script&lang=js&"
export * from "./sendEmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./sendEmailDetail.vue?vue&type=style&index=0&id=59d8f9cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8f9cc",
  null
  
)

export default component.exports